import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  withdrawlHeader: { alignItems: 'center', flexDirection: 'row' },
});

export default styles;
